module.exports = __webpack_public_path__ + "img/logo-sm-light.cf779a59.png";